import { atom } from "recoil";

export interface WebTestType {
  type?: string; // a or b
}

export const webTestTypeAtom = atom<WebTestType | undefined>({
  key: "WebTestType",
  default: undefined,
});
